export default __webpack_public_path__ + "f8e3d50aa5e79c9a1ae362161663bef3.png";